module.exports = __webpack_public_path__ + "img/FOCOOP.46e4ba38.webp";